import { IClient } from '~/services/api/client/types';

export enum ClientAction {
  ARCHIVE = 'archive',
  RESTORE = 'restore',
}

export interface IClientAction {
  action: ClientAction;
  client: IClient;
}
